var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sprite',{ref:"sprite",attrs:{"id":_vm._f("slugy")(_vm.png),"spritesheet":_vm.png,"json":_vm.json,"yoyo":false,"fps":_vm.fps}})}
var staticRenderFns = []

export { render, staticRenderFns }